<template>
  <input name="_token" type="hidden" :value="csrfToken" />
</template>

<script>
// @flow
import { mapState } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'

/**
 * Helper to add csrf to laravel post forms
 * This is already handled for xhr / fetch requests
 */
export default {
  name: 'CsrfInput',
  computed: mapState(useUserAuthStore, ['csrfToken']),
}
</script>
